module.exports = __webpack_public_path__ + "media/images/admin/icons/codepen-4a048dd62b63bb3ee66818b169db544d.svg";